import styles from "./index.module.css";
import { Button } from "@mui/material";
import errorImage from "../../../assets/error.svg";
import { useTranslation } from "react-i18next";

export const ComponentError = ({ code }) => {
  const { t } = useTranslation();
  if (code === "Failed to fetch") {
    code = 503;
  }

  return (
    <div className={styles.container}>
      <img className={styles.errorImage} src={errorImage} alt="Error" />
      <div className={code * 1 >= 500 ? styles.title500 : styles.title}>
        {code * 1 >= 500 ? t("tryInOtherMoment") : t("sorryErrorOcurred")}
      </div>
      <div className={styles.errorCode}>
        ({t("error")}: {code})
      </div>
      <div className={styles.container_error}>
        <Button
          onClick={() => window.location.reload()}
          variant="contained"
          sx={{ marginTop: 2 }}
        >
          {t("retry")}
        </Button>
      </div>
    </div>
  );
};
